import React from "react";
import { Form, Row, Col, Select } from "antd";
import CustomDropdown from "../../../../components/custom-dropdown/custom-dropdown";
import styles from "./dealer.module.css";
import { TDropdownOptions } from "../../../../types/config";
import { GetUserList } from "../../../../utils/api.constant";
import { eMAPPED_DEALER_VIEW, eRoles } from "../../../../utils/enum";
import { STAKE_HOLDERS } from "../../../../utils/constants";

interface MappingFormProps {
  servicePartner: number | null;
  primaryEngineer: TDropdownOptions | undefined;
  secondaryEngineer: TDropdownOptions | undefined;
  serviceEscalation: TDropdownOptions | undefined;
  serviceCordinator: TDropdownOptions | undefined;
  servicePartnerOptions: TDropdownOptions[];
  activeUser?: any;
  setPrimaryEngineer: (value: TDropdownOptions) => void;
  setSecondaryEngineer: (value: TDropdownOptions) => void;
  setServiceEscalation: (value: TDropdownOptions) => void;
  setServiceCordinator: (value: TDropdownOptions) => void;
  setServicePartner?: (value: number | null) => void;
  disableServicePartner?: boolean;
  customerId: number;
}

const MappingForm: React.FC<MappingFormProps> = ({
  servicePartner,
  primaryEngineer,
  secondaryEngineer,
  serviceEscalation,
  serviceCordinator,
  servicePartnerOptions,
  activeUser,
  setPrimaryEngineer,
  setSecondaryEngineer,
  setServiceEscalation,
  setServiceCordinator,
  setServicePartner,
  disableServicePartner = false,
  customerId,
}) => {
  return (
    <Form name="register" layout="vertical">
      <Row
        gutter={16}
        className="formRowHeight"
        style={{ marginTop: "1.5rem" }}
      >
        <Col span={24}>
          <Form.Item
            label={<span className={styles.customLabel}>Service Partner</span>}
            rules={[
              {
                required: true,
                message: "Please choose service partner",
              },
            ]}
          >
            <Select
              value={servicePartner ?? null}
              disabled={
                activeUser?.stakeHolderName === STAKE_HOLDERS.SERVICEPARTNER ||
                disableServicePartner
                  ? true
                  : false
              }
              onChange={(selected: any) => {
                setServicePartner?.(selected);
                setPrimaryEngineer({ value: null, label: "" });
                setSecondaryEngineer({ value: null, label: "" });
                setServiceEscalation({ value: null, label: "" });
                setServiceCordinator({ value: null, label: "" });
              }}
              placeholder="Select Service Partner"
              options={servicePartnerOptions}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16} className="formRowHeight">
        <Col span={24}>
          <Form.Item
            label={<span className={styles.customLabel}>Primary Engineer</span>}
          >
            <CustomDropdown
              isDisabled={servicePartner ? false : true}
              endPoint={GetUserList}
              value={primaryEngineer?.value}
              selectedName={primaryEngineer?.label}
              onChange={(selected: any) => {
                setPrimaryEngineer({
                  label: selected.label,
                  value: selected.value,
                });
              }}
              label=""
              placeHolder="Select engineer"
              optionName="displayName"
              optionId="id"
              addPaylod={{
                stakeHolderName: STAKE_HOLDERS.SERVICEPARTNER,
                orgId: servicePartner,
                roleUniqueId: eRoles.SERVICEENGINEER,
                servicePartnerId: servicePartner,
                mappedDealerViewId: eMAPPED_DEALER_VIEW.MAPPEDDEALER,
                customerId,
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16} className="formRowHeight">
        <Col span={24}>
          <Form.Item
            label={
              <span className={styles.customLabel}>Secondary Engineer</span>
            }
          >
            <CustomDropdown
              isDisabled={servicePartner ? false : true}
              endPoint={GetUserList}
              value={secondaryEngineer?.value}
              selectedName={secondaryEngineer?.label}
              onChange={(selected: any) => {
                setSecondaryEngineer({
                  label: selected.label,
                  value: selected.value,
                });
              }}
              label=""
              placeHolder="Select engineer"
              optionName="displayName"
              optionId="id"
              addPaylod={{
                stakeHolderName: STAKE_HOLDERS.SERVICEPARTNER,
                orgId: servicePartner,
                roleUniqueId: eRoles.SERVICEENGINEER,
                servicePartnerId: servicePartner,
                mappedDealerViewId: eMAPPED_DEALER_VIEW.MAPPEDDEALER,
                customerId,
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16} className="formRowHeight">
        <Col span={24}>
          <Form.Item
            label={
              <span className={styles.customLabel}>Service Cordinator</span>
            }
          >
            <CustomDropdown
              isDisabled={servicePartner ? false : true}
              endPoint={GetUserList}
              value={serviceCordinator?.value}
              selectedName={serviceCordinator?.label}
              onChange={(selected: any) => {
                setServiceCordinator({
                  label: selected.label,
                  value: selected.value,
                });
              }}
              label=""
              placeHolder="Select service cordinator"
              optionName="displayName"
              optionId="id"
              addPaylod={{
                stakeHolderName: STAKE_HOLDERS.SERVICEPARTNER,
                orgId: servicePartner,
                roleUniqueId: eRoles.SERVICECORDINATOR,
                servicePartnerId: servicePartner,
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16} className="formRowHeight">
        <Col span={24}>
          <Form.Item
            label={
              <span className={styles.customLabel}>Service Escalation</span>
            }
          >
            <CustomDropdown
              isDisabled={servicePartner ? false : true}
              endPoint={GetUserList}
              value={serviceEscalation?.value}
              selectedName={serviceEscalation?.label}
              onChange={(selected: any) => {
                setServiceEscalation({
                  label: selected.label,
                  value: selected.value,
                });
              }}
              label=""
              placeHolder="Select service escalation"
              optionName="displayName"
              optionId="id"
              addPaylod={{
                stakeHolderName: STAKE_HOLDERS.SERVICEPARTNER,
                orgId: servicePartner,
                roleUniqueId: eRoles.SERVICEESCALATION,
                servicePartnerId: servicePartner,
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default MappingForm;
